import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../../../@vex/layout/layout.module';
import { ApplicationLayoutComponent } from './application-layout.component';
import { SidenavModule } from '../../../../@vex/layout/sidenav/sidenav.module';
import { ToolbarModule } from '../../../../@vex/layout/toolbar/toolbar.module';
import { FooterModule } from '../../../../@vex/layout/footer/footer.module';
import { SidebarModule } from '../../../../@vex/components/sidebar/sidebar.module';
import { QuickpanelModule } from '../../../../@vex/layout/quickpanel/quickpanel.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UiModule } from '../../ui/ui.module';
import { IconModule } from '@abhinavakhil/iconify-angular';
import { FlexModule } from '@ngbracket/ngx-layout';
import { ProfilComponent } from './profil/profil.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseModule } from '../../base/base.module';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { PageLayoutModule } from '../../../../@vex/components/page-layout/page-layout.module';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { NotificationComponent } from './notification/notification.component';
import { NotificationCreateUpdateDeleteComponent } from './notification/notification-create-update-delete/notification-create-update-delete.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { ForbiddenComponent } from './unauthorized/forbidden.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { LottieModule } from 'ngx-lottie';
import { ManagementRoutingModule } from '../../../pages/application/management/management-routing.module';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { ProfilCreateUpdateDeleteComponent } from './profil/profil-create-update-delete/profil-create-update-delete.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { InprogressComponent } from './inprogress/inprogress.component';
import { NgChartsModule } from 'ng2-charts';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { ContentSplitLayoutComponent } from './content-split-layout/content-split-layout.component';
import { CoreModule } from '../../core.module';

export function playerFactory(): any {
  return import('lottie-web');
}

@NgModule({
  declarations: [
    ApplicationLayoutComponent,
    DashboardComponent,
    ProfilComponent,
    NotificationComponent,
    NotificationCreateUpdateDeleteComponent,
    ForbiddenComponent,
    NotFoundComponent,
    MaintenanceComponent,
    ProfilCreateUpdateDeleteComponent,
    InprogressComponent,
    ContentSplitLayoutComponent,
  ],
  exports: [ContentSplitLayoutComponent],
  imports: [
    CommonModule,
    CoreModule,
    LayoutModule,
    SidenavModule,
    ToolbarModule,
    FooterModule,
    SidebarModule,
    QuickpanelModule,
    UiModule,
    IconModule,
    FlexModule,
    PageLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    BaseModule,
    MatSnackBarModule,
    MatSelectModule,
    MatTooltipModule,
    MatSlideToggleModule,
    FormsModule,
    ManagementRoutingModule,
    LottieModule.forRoot({ player: playerFactory }),
    MatTabsModule,
    MatDialogModule,
    NgChartsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTableModule,
    MatMenuModule,
  ],
})
export class ApplicationLayoutModule {}
